import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-subscription-listing',
  templateUrl: './subscription-listing.component.html',
  styleUrls: ['./subscription-listing.component.scss'],
})
export class SubscriptionListingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
